// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"OQ-z","inlineTitle":"PQ-z","sponsoredAdsWrapper":"QQ-z","marketplaceRecosWrapper":"RQ-z"};